export default __webpack_public_path__ + "static/ProblemSolving-538adefd02dba7593b8d1dafc4a5d18f.jpg";